import { defineComponent as _defineComponent } from 'vue'
import { reactive, computed, watch } from 'vue';
import {
  parsePhoneNumber,
  AsYouType,
  CountryCode,
  validatePhoneNumberLength,
} from 'libphonenumber-js';

import { countryInfo } from '@values/countries';

import CountryFlag from '@components/CountryFlag.vue';

import FormInput from './FormInput.vue';
import FormSelect from './FormSelect.vue';

/**
 * `FormPhone` component properties.
 */
export interface Props {
  value?: string | null;
  label?: string;
  state?: boolean | null;
}

interface CountryCodeInfo {
  countryCode: string;
  dialCode: string;
  flag: string;
}


const __default__ = { name: 'FormPhone' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: { default: null },
    label: { default: 'Phone Number' },
    state: { type: [Boolean, null], default: null }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { value: string | null, label: string, state: boolean | null };





const countryCodeOptions: ZephyrWeb.OptionItem<CountryCodeInfo>[] =
  Object.values(countryInfo).map((item) => ({
    text: `${item.dialCode} ${item.code}`,
    value: {
      countryCode: item.code,
      dialCode: item.dialCode,
      flag: item.flag,
    },
  }));

const fieldData = reactive(initializeFieldData(props.value));

const countryCode = computed(() => {
  return fieldData.country?.countryCode ?? null;
});

const parsedNumber = computed(() => {
  return parseNumber(
    (fieldData.country?.dialCode ?? '') + (fieldData.number ?? ''),
  );
});

watch(parsedNumber, (value) => {
  emit('input', value?.number ?? null);
});

//#region Helper Functions

function getCountry(code: string) {
  return (
    countryCodeOptions.find(({ value }) => value.countryCode === code)?.value ??
    countryCodeOptions[0]?.value ??
    null
  );
}

function parseNumber(value: string) {
  let parsedNumber;

  try {
    parsedNumber = parsePhoneNumber(value);
  } catch {
    // ...
  }

  return parsedNumber ?? null;
}

function asYouType(value: string) {
  if (!fieldData.country) return;

  if (
    validatePhoneNumberLength(
      value,
      fieldData.country.countryCode as CountryCode,
    ) === 'TOO_LONG'
  ) {
    // Stop the input if possible?
    return;
  }

  try {
    fieldData.number = new AsYouType(
      fieldData.country.countryCode as CountryCode,
    ).input(value);
  } catch {
    //
  }
}

/**
 * ...
 */
function initializeFieldData(value: string | null) {
  let country = getCountry('US');

  let number: string | null = null;

  const parsedNumber = parseNumber(value ?? '');

  if (parsedNumber?.country) {
    country = getCountry(parsedNumber.country);
    number = parsedNumber.nationalNumber;
  }

  return { country, number };
}

//#endregion Helper Functions

return { __sfc: true,props, emit, countryCodeOptions, fieldData, countryCode, parsedNumber, getCountry, parseNumber, asYouType, initializeFieldData, CountryFlag, FormInput, FormSelect }
}

})